import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import FoodModalUpdate from "./FoodModalUpdate/FoodModalUpdate";
import "./CardDetails/CardDetails.css";
import bin from "../../../Assets/Icons/recycle-bin.png";
//import edit from '../../../Assets/Icons/editPencil.png';
import edit from "../../../Assets/Icons/edit.png";
import "./ItemDetails.css";
import { Skeleton } from "antd";
import { getPercentageOrAmount } from "../../../utils/getPercentageOrAmount";
import { sliceText } from "../../../utils/sliceText";
import { useDispatch } from "react-redux";
import { decreaseItemCount } from "../../../reducers/cartCounterReducer";

const ItemDetails = ({
  item,
  onUpdateCart,
  onDeleteCart,
  cart,
  setCart,
  getItemDetails,
  reloadingCart,
}) => {
  const [quantity, setQuantity] = useState(item.foodItemQuantity);
  const [total, setTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const dispatch = useDispatch();

  console.log(item, "item__");

  useEffect(() => {
    const calculateTotalPrice = () => {
      let totalValue = item.basePrice * item.foodItemQuantity;
      let totalWithoutVat = item.basePrice * item.foodItemQuantity;
      for (let i = 0; i < item.addOns.length; i++) {
        const addOnPrice =
          item.addOns[i].addOnBasePrice * item.addOns[i].addOnQuantity;
        totalValue += addOnPrice;
        totalWithoutVat += addOnPrice;

        for (let j = 0; j < item.addOns[i].options.length; j++) {
          const optionPrice =
            item.addOns[i].options[j].optionBasePrice *
            item.addOns[i].options[j].optionQuantity;
          totalValue += optionPrice;
          totalWithoutVat += optionPrice;

          for (
            let k = 0;
            k < item.addOns[i].options[j].subOptions.length;
            k++
          ) {
            const subOptionPrice =
              item.addOns[i].options[j].subOptions[k].subOptionBasePrice *
              item.addOns[i].options[j].subOptions[k].subOptionQuantity;
            totalValue += subOptionPrice;
            totalWithoutVat += subOptionPrice;
          }
        }
      }

      setSubTotal(totalWithoutVat);
      setTotal(totalValue.toFixed(2));
    };

    calculateTotalPrice();
  }, [item]);

  // useEffect(() => {
  //   const calculateServiceCharge = () => {
  //     if (cart.length > 0) {
  //       for (let i = 0; i < cart.length; i++) {
  //         for (let j = 0; j < cart[i].subOrders.length; j++) {
  //           if (cart[i].subOrders[j].orderTypeName === "In-Store") {
  //             const service = getPercentageOrAmount(subTotal, cart[i].serviceCharge, "amount");
  //             // console.log("new cart fadsa: ", subTotal, cart[i].serviceCharge, service);
  //             updateServiceCharge(service);
  //           } else {
  //             updateServiceCharge(0)
  //           }
  //         }
  //       }
  //     }
  //   }

  //   calculateServiceCharge();
  // }, [cart, subTotal]);

  // const handleDecrease = () => {
  //   if (quantity > 1) {
  //     setQuantity(quantity - 1);
  //   }
  // };

  // const handleIncrease = () => {
  //   setQuantity(quantity + 1);
  // };
  // console.log("data from cart item details: ", cart)
  // console.log("data for item details: ", item)

  // const handleQuantityChange = (qunatity) => {
  //   // Update the item quantity in the cart

  //   const updatedCart = cart.map((restaurant) => {
  //     if (restaurant.resturantMapperId === item.cartRestaurantMapperId) {
  //       const updatedItems = restaurant.itemDetails.map((cartItem) => {
  //         if (cartItem.id === item.id) {
  //           return { ...cartItem, qunatity };
  //         }
  //         return cartItem;
  //       });
  //       return { ...restaurant, itemDetails: updatedItems };
  //     }
  //     return restaurant;
  //   });

  //   // Update the cart state
  //   setCart(updatedCart);

  //   // Call the parent component's function to update the cart in the API
  //   onUpdateCart(updatedCart);
  // };

  //  this update api call unnecessary thats why comment it

  // const updateFoodQuantity = useCallback(async () => {
  //   if (item.cartItemId && quantity) {
  //     try {
  //       const response = await axios.patch(`${process.env.REACT_APP_SECRET}/api/Cart/UpdateFoodItemQuantity/${item.cartItemId}?quantity=${quantity}`);

  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // }, [item.cartItemId, quantity]);

  // useEffect(() => {
  //   const updatedItem = setTimeout(updateFoodQuantity, 300);

  //   return () => clearTimeout(updatedItem);
  // }, [updateFoodQuantity])

  const handleDeleteItem = async (item) => {
    const url = `${process.env.REACT_APP_SECRET}/api/Cart/DeleteFoodItem`;
    const params = {
      foodItemId: item.foodItemId,
      subOrderId: item.subOrderId,
      restaurantId: item.restaurantId,
      cartFoodItemId: item.cartItemId,
      orderTypeId: item.orderTypeId,
      orderId: item.orderId,
    };

    // Show SweetAlert confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
        customClass: {
          container: "swal-high-zindex"
        }
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(url, { params });
        if (response.data) {
          dispatch(decreaseItemCount(1));
        }
      } catch (error) {
        Swal.fire("Error!", "There was a problem deleting your item.", "error");
      }
      reloadingCart();
    }
  };

  //   const handleDeleteItem = async (item) => {
  //   // // Remove the item from the cart
  //   // let id = itemId;
  //   // const updatedCart = cart.map((restaurant) => {
  //   //   if (restaurant.resturantMapperId === item.cartRestaurantMapperId) {
  //   //     const updatedItems = restaurant.itemDetails.filter(
  //   //       (cartItem) => cartItem.id !== item.id
  //   //     );
  //   //     return { ...restaurant, itemDetails: updatedItems };
  //   //   }
  //   //   return restaurant;
  //   // });

  //   // // Update the cart state
  //   // setCart(updatedCart);

  //   // // Call the parent component's function to update the cart in the API
  //   // onDeleteCart(id);
  // };

  const findOrderType = (orderTypeId) => {
    if (orderTypeId === "7CD55767-82AF-4912-AA5B-DCCBB9CCC68A") {
      return "Delivery";
    } else if (orderTypeId === "0DEB06FD-2D9D-49EA-8E17-44E2958E1056") {
      return "Dine-In";
    }
    else if (orderTypeId === "F54272CD-371F-44F9-A8AC-34C30C2DC4FE") {
      return "Collection";
    }
  };

  return item !== null ? (
    <div>
      <div
        className='d-flex mt-3 cartdetailsGrid justify-content-between'
        style={{ cursor: "pointer", padding: "0 14px" }}
      >
        <div
          className='d-flex itemDetailsAndImage'
          onClick={() => getItemDetails(item)}
        >
          <div className='cart-item-image'>
            <img src={item?.foodItemImage} alt='cart food item' />
          </div>
          <div className='d-flex productDetails flex-column ps-2 pb-2'>
            {/* Food Item */}
            <h5 className='large-tooltips' data-title={item?.foodItemName}>
              {sliceText(item?.foodItemName, 17)} x{item?.foodItemQuantity}{" "}
              <span className='fooditem-price' style={{ marginLeft: "0.4rem" }}>
                £{item.basePrice * item?.foodItemQuantity}{" "}
                <em className='fst-italic text-dark small'>
                  ({findOrderType(item?.orderTypeId)})
                </em>
              </span>
            </h5>

            {/* AddOns with nested options & suboptions */}
            {item?.addOns?.map(
              (addOn) =>
                addOn?.addOnQuantity > 0 && (
                  <div key={addOn.addOnId} className='ms-2'>
                    <h6 className='addOn'>
                      {addOn.addOnName} x{addOn.addOnQuantity}
                      <span style={{ marginLeft: "0.4rem", fontSize: "1em" }}>
                        {" "}
                        £{addOn.addOnQuantity * addOn.addOnBasePrice}
                      </span>
                    </h6>

                    {/* Options under addon */}
                    {addOn?.options?.map(
                      (option) =>
                        option?.optionQuantity > 0 && (
                          <h6
                            key={option.optionId}
                            style={{ marginLeft: "1.5rem" }}
                            className='option'
                          >
                            {option.optionName} x{option.optionQuantity}
                            <span
                              style={{
                                marginLeft: "0.4rem",
                                fontSize: "1em",
                              }}
                            >
                              {" "}
                              £{option.optionQuantity * option.optionBasePrice}
                            </span>
                            {/* SubOptions under option */}
                            {option?.subOptions?.map((sub) => (
                              <span
                                key={sub.subOptionId}
                                className='span-text suboption'
                                style={{
                                  marginLeft: "0.5rem",
                                  display: "inline-block",
                                  fontSize: "0.95em",
                                }}
                              >
                                ({sub.subOptionName} x{sub.subOptionQuantity} £
                                {sub.subOptionQuantity * sub.subOptionBasePrice}
                                )
                              </span>
                            ))}
                          </h6>
                        )
                    )}
                  </div>
                )
            )}
          </div>
        </div>
        <div className='d-flex flex-column itemIcon'>
          <div className='d-flex  price-Div'>
            <p className='price d-flex justify-content-end'>£{total}</p>
            {/* <div className='d-flex align-items-center quantity'>
            <span
              className='plus-icon'
              onClick={() => setQuantity((prev) => prev > 1 ? prev - 1 : 1)}
            >
              -
            </span>
            {quantity}
            <span
              className='plus-icon'
              onClick={() => setQuantity((prev) => prev + 1)}
            >
              +
            </span>
          </div> */}
          </div>
          <div className='d-flex justify-content-end'>
            <span style={{ marginRight: "1rem" }}>
              <img
                src={edit}
                alt='edit'
                style={{ width: "1.5rem", height: "1.5rem" }}
                onClick={() => getItemDetails(item)}
              />
            </span>

            <span>
              <img
                src={bin}
                alt=''
                style={{ width: "1.5rem", height: "1.5rem" }}
                onClick={() => handleDeleteItem(item)}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className='d-flex mt-3 cartdetailsGrid justify-content-between'>
      <div className='d-flex itemDetailsAndImage'>
        <Skeleton.Avatar
          size={120}
          shape='square'
          style={{
            marginRight: "16px",
            marginLeft: "4px",
            borderRadius: "10px",
          }}
        />
        <div className='d-flex productDetails justify-content-center ps-4 pb-2'>
          <h5>
            <Skeleton.Input style={{ width: "150px" }} active />
          </h5>
          <div className='options addOnCart'>
            <h6>
              <Skeleton.Input style={{ width: "100px" }} active />
            </h6>
          </div>
        </div>
      </div>
      <div className='d-flex itemDetailsAndImage'>
        <div className='d-flex productDetails justify-content-center ps-4 pb-2'>
          <h5>
            <Skeleton.Input style={{ width: "150px" }} active />
          </h5>
          <div className='options addOnCart'>
            <h6>
              <Skeleton.Input style={{ width: "100px" }} active />
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDetails;
